import type {
  ComponentPropsWithoutRef,
  FunctionComponent,
  ReactNode,
} from 'react'
import React from 'react'

import classNames from 'classnames'

import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import styles from './Grouper.module.scss'

export const Grouper: FunctionComponent<GrouperProps> = ({
  groups,
  className,
  ...rest
}) => {
  if (!groups?.length) {
    return null
  }

  return (
    <ol
      className={classNames(className, styles.grouper)}
      data-testid="grouper"
      {...rest}
    >
      {groups.map((group) => {
        return group.children?.length ? (
          <li
            className={styles.group}
            aria-labelledby={`${group.name}-label`}
            key={group.key}
          >
            <TypographyV2
              tag="h2"
              textStyle="sb-text-interface-body-small-regular"
              className={styles.groupHeading}
              id={`${group.name}-label`}
            >
              {group.name}
            </TypographyV2>
            <ol
              className={styles.groupItems}
              aria-labelledby={`${group.name}-label`}
            >
              {group.children?.map((child) => (
                <li key={child.key}>{child.content}</li>
              ))}
            </ol>
          </li>
        ) : null
      })}
    </ol>
  )
}

///////// IMPLEMENTATION /////////

export type GrouperProps = {
  /**
   * List of groups to be displayed along with their children. Groups and group children must have a key provided.
   */
  groups: {
    name: string
    key: string
    children: {
      key: string
      content: ReactNode
    }[]
  }[]
  /**
   * Optional CSS class name that can be added to the outer ordered list.
   */
  className?: string
} & ComponentPropsWithoutRef<'ol'>
